export const FETCH_MQTT_CHANNEL_LIST_STARTED = 'FETCH/USER/HISTORY/LIST/STARTED';
export const FETCH_MQTT_CHANNEL_LIST_SUCCESS = 'FETCH/USER/HISTORY/LIST/SUCCESS';
export const FETCH_MQTT_CHANNEL_LIST_FAILURE = 'FETCH/USER/HISTORY/LIST/FAILURE';
